import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { map } from 'rxjs/operators'; 
import { TCCPHttpResponseHandler } from './tccp-http-response-handler.service';
import { LoaderService } from '../loader/loader.service';
import { TCCPLocalStorageService } from './tccp-local-storage.service';

/**
 * DOS Http service to wrap around REST Calls.
 */
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'my-auth-token'
    })
};
@Injectable()
export class TCCPHttpService {
    private baseUrl = '';

    constructor(private http: HttpClient, private responseHandler: TCCPHttpResponseHandler, private loaderService: LoaderService, private storageService: TCCPLocalStorageService) {
        /*this.baseUrl = this.configService.get('api').baseUrl;*/
    }

    /**
     * GET method requests a resource from the server along with query parameters if required
     * @param path
     * @param params
     */
    // get(path: string, params: URLSearchParams = new URLSearchParams()): Observable<any> {
    //     this.showLoader();
    //     const timeStart: number = performance.now();
    //     return this.http.get(`${this.baseUrl}${path}`, { headers: this.setHeaders() })
    //         .catch((err, source) => this.responseHandler.onCatch(err, source))
    //         .map((res: Response) => this.responseHandler.onSuccess(res, timeStart));
    // }

    get(path: string, params: HttpParams = new HttpParams()){
        this.showLoader();
        const timeStart: number = performance.now();
        return this.http.get(`${this.baseUrl}${path}`, { headers: this.setHeaders() }).pipe(
            map((res: Response) => this.responseHandler.onSuccess(res, timeStart)),
            catchError((err, source) => this.responseHandler.onCatch(err, source))
            
        );

            
    }






    /**
     * Utility method for Update.
     * @param path
     * @param params
     */
    put(path: string, body: Object = {}): Observable<any> {
        this.showLoader();
        const timeStart: number = performance.now();
        return this.http.put(
            `${this.baseUrl}${path}`,
            JSON.stringify(body),
            { headers: this.setHeaders() }
        ).pipe(
            map((res: Response) => this.responseHandler.onSuccess(res, timeStart)),
            catchError((err, source) => this.responseHandler.onCatch(err, source))
        );
    }

    /**
    * DELETE method requests a resource from the server along with query parameters if required
    * @param path
    * @param params
    */

    delete(path: string, body: Object = {}): Observable<any> {
        this.showLoader();
        const timeStart: number = performance.now();
        return this.http.delete(
            `${this.baseUrl}${path}`,
            { headers: this.setHeaders() },
        ).pipe(
            map((res: Response) => this.responseHandler.onSuccess(res, timeStart)),
            catchError((err, source) => this.responseHandler.onCatch(err, source))
        );
    }

    /**
     * Utility method for Create.
     * @param path
     * @param params
     */

    post(path: string, body: Object = {}): Observable<any> {
        this.showLoader();
        const timeStart: number = performance.now();
        return this.http.post(
            `${this.baseUrl}${path}`,
            JSON.stringify(body),
            { headers: this.setHeaders() }
        ).pipe(
            map((res: Response) => this.responseHandler.onSuccess(res, timeStart)),
            catchError((err, source) => this.responseHandler.onCatch(err, source))
        );
    }


    /**
     * Set  HTTP Headers
     */
    private setHeaders(): HttpHeaders {
        const tokenData = this.storageService.getToken();
        let token = null;
        if (tokenData) {
            const parsed = JSON.parse(tokenData);
            token = parsed.token;
        }

        const headersConfig = {
            'Content-Type': 'application/json',
            Authorization: token ? `Bearer ${token}` : 'my-auth-token'
        };
        return new HttpHeaders(headersConfig);
    }

    /**
     * Format errors - later have TCCPExceptionHandler and
     * TCCPLogger to handle exceptions and error messages.
     * @param error
     */
    private formatErrors(error: any) {
        return throwError(() => error.json());
    }


    private showLoader(): void {
        this.loaderService.show();
    }

    private hideLoader(): void {
        this.loaderService.hide();
    }

    /**
    * Utility method for File Download.
    * @param path
    * @param params
    */
    // downloadFileByPost(path: string, body: Object = {}): Observable<any> {
    //     this.showLoader();
    //     const headers = new HttpHeaders();
    //     headers.append('Content-Type', 'application/json');
    //     headers.append('responseType', 'arrayBuffer');
    //     return this.http.post(`${this.baseUrl}${path}`, JSON.stringify(body),
    //         { observe: 'response', headers: this.setHeaders(), responseType: 'blob' })
    //         .catch((err, source) => this.responseHandler.onCatch(err, source))
    //         .map((res: Response) => this.responseHandler.downloadonSuccess(res));
    // }

    downloadFileByPost(path: string, body: Object = {}): Observable<any> {
        this.showLoader();
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        headers.append('responseType', 'arrayBuffer');
        return this.http.post(`${this.baseUrl}${path}`, JSON.stringify(body),
            { observe: 'response', headers: this.setHeaders(), responseType: 'blob' }).pipe(
            map((res: any) => this.responseHandler.downloadonSuccess(res)),
            catchError((err, source) => this.responseHandler.onCatch(err, source))
            );
    }
}

